import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { IErrorCode, IFile, ISharememberInviteData } from 'src/sync';
import { BaseApiOutput, BlendEvent, Constants, ErrCode } from '../../models';
import { Base64Service } from 'src/app/core/base64.service';
import { UserService } from 'src/app/core/user.service';
import { ValidateService } from 'src/app/core/validate.service';
import { FileListService } from 'src/app/file-list/services/file-list.service';
import { LoggerService } from 'src/app/core/logger.service';
import { ShareService } from '../../services/share.service';
import { JoblockService } from 'src/app/core/joblock.service';
import { Store } from '@ngrx/store';
import { FeatureService } from '../../services/feature.service';
import { State } from 'src/app/reducers';
import { ShareNewService } from '../../services/share-new.service';
import { SnackbarService } from '../../services/snackbar.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { BlendService } from '../../services/blend.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dialog-share-new',
  templateUrl: './dialog-share-new.component.html',
  styleUrls: ['./dialog-share-new.component.scss']
})
export class DialogShareNewComponent implements OnInit, OnDestroy {

  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() state = new EventEmitter<number>();

  @Output() shareFolderSuccess = new EventEmitter<boolean>();

  @Input() selected: IFile[] = [];
  @Input() pid: number;

  @Input() showDialog: boolean = true;
  @Input() isNewFolder?: boolean = false;
  @Input() filename?: string;
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  public loadingOnShareInfo = false;

  public isVerified: boolean;
  public isShareLimit = false;
  public spinnerOnSubmit: boolean = false;
  public syncId: number;
  public completed: number;
  public count: number;
  public errors: Array<IErrorCode> = [];
  public validate: any;
  public shareId: number;
  public cachekey: string;
  public inviteKey: string;
  public sharekey: string;
  public mkshareJob: any;
  public sync_id: number;

  private shareJobSubscription: Subscription;
  private breakpointSubscribe: Subscription;
  private filelistSubscription: Subscription;

  public currentLoadPercentage: number;
  public startingTime: Date;
  public totalCompletionTime = 1; // Example: 10 minutes
  public timerInterval: any;
  public isJobComplete = false;
  public shareAddJob: BaseApiOutput;
  public jobStatus: string;
  public bg: number;
  public errorMessage: string = '';

  private pathlist: IFile[];
  private cwd: IFile;

  public sharememberInvite: ISharememberInviteData = {
    permissions: {
      'perDOWNLOAD': 1,
      'perUPLOAD': 1,
      'perINVITE': 0,
      'perSEEOTHERS': 1,
      'perADDAPP': 0,
    },
    displayName: this.base64Service.decode(this.userService.get('display_name')),
    queue: [],
    roleQueue: [],
    roleName: '',
    privateMessage: ''
  };
  newShareFolderNameValid = true;
  public errcode: ErrCode;
  // newshareform = new FormGroup({
  //   filename: new FormControl('', [
  //     Validators.required, this.leadingSpace.bind(this), this.trailingChar.bind(this),
  //      this.reservedNames.bind(this),
  //   this.illegalCharacters.bind(this), this.exist.bind(this)])
  // });
  public isSmallScreen: boolean = false;

  constructor(
    private base64Service: Base64Service,
    private userService: UserService,
    private validateService: ValidateService,
    private fileListService: FileListService,
    private loggerService: LoggerService,
    private shareService: ShareService,
    private shareNewService: ShareNewService,
    private JobLockService: JoblockService,
    private store: Store<State>,
    private FeatureService: FeatureService,
    public breakpointObserver: BreakpointObserver,
    private snackbarService: SnackbarService,
    private blendService: BlendService,
    private route: ActivatedRoute
  ) {
    this.isVerified = this.userService.get('is_verified');
    // this.isChecking = true;
    this.completed = 0;
    this.validate = this.validateService;
    this.pid = 0;
    if (this.selected.length && this.selected[0]) {
      this.filelistSubscription = this.fileListService.getListSubscription()
        .subscribe((data) => {
          if (data && data.cwd) {
            this.cwd = data.cwd;
          }
          if (this.selected[0].sync_id == data.cwd.sync_id) {
            if (data && data.pathlist.length) {
              this.pathlist = data.pathlist;
            }
          }
        });
    }
  }

  folderNameChange = (name: string) => {
    this.filename = name;
    this.errorMessage = '';
    this.errcode = null;
    this.errors = [];
  }
  
  exist = (fileName) => {
    if (!this.pathlist) { return true; }
    if (this.validateService.isEmpty(fileName)) { return true; }
    const found = this.pathlist.filter((val) => {
      return (val.name.toLowerCase() == fileName.toLowerCase());
    });
    return !(found && found.length > 0) ? null : { 'exist': true };
  }

  async ngOnInit() {
    this.breakpointSubscribe = this.breakpointObserver.observe([
      '(max-width: 599px)',
    ])
    .subscribe((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 599px)']) {
        this.isSmallScreen = true;
      } else {
        this.isSmallScreen = false;
      }
      
    });  
    this.bg = await this.FeatureService.isAllowed('breakup-makelink') ? 1 : 0;
    this.init();
  }

  ngOnDestroy(): void {
    if (this.shareJobSubscription) {
      this.shareJobSubscription.unsubscribe();
    }
    if (this.breakpointSubscribe) {
      this.breakpointSubscribe.unsubscribe();
    }
    if (this.filelistSubscription) {
      this.filelistSubscription.unsubscribe();
    }
  }

  public exists = (value: string, isPristine: boolean) => {
    if (isPristine || this.validateService.isEmpty(value)) { return true; }
    if (!this.pathlist) { return true; }
    const found = this.pathlist.filter((val) => {
      return (val.name.toLowerCase() == value.toLowerCase());
    });
    return !(found && found.length > 0);
  }
  private init = async () => {
    this.syncId = null;
    this.loadingOnShareInfo = true;
    try {
      let data;
      if (this.selected && this.selected.length && this.selected[0]) {
        const item = this.selected[0];
        this.syncId = item.sync_id;
        this.filename = item.name;
      } else if (this.pid && this.pid != 0) {
        data = await this.fileListService.getDataNoState(this.pid, '0');
        this.pathlist = data.pathlist;
        // } else if (this.cwd && this.User.get('syncus_sync_id') != this.cwd.sync_id) {
        //     this.pid = this.User.get('syncus_sync_id');
        //     data = this.FileList.getDataNoState(this.User.get('syncus_sync_id'), '0');
      } else {
        this.pid = this.userService.get('syncus_sync_id');
        data = await this.fileListService.getDataNoState(this.userService.get('syncus_sync_id'), '0');
        this.pathlist = data.pathlist;
      }
      await this.shareNewService.checkShare(this.syncId);
      this.isShareLimit = false;
    } catch (ex) {
      if (ex && ex.error_code == 8027) {
        this.isShareLimit = true;
      } else {
        this.handleErr(ex);
      }
    }
    this.loadingOnShareInfo = false;
  }

  shareMemberInviteChange = (value: any) => {
    this.sharememberInvite = value;
    this.newShareFolderNameValid = !((!!this.sharememberInvite?.queue?.length || !!this.sharememberInvite?.roleQueue?.length) && !this.spinnerOnSubmit && !this.isShareLimit)
  }

  isFormValid(): boolean {
    return (
      !!this.filename &&
      !!this.sharememberInvite.displayName &&
      (this.isVerified && !this.isShareLimit)
    );
  }

  public async postmkShareSteps() {
    if (this.bg == 1) {
      await this.JobLockService.pollJobStatus();
      this.loggerService.info({ func: 'postShareJobCompleteAction', inviteKey: this.inviteKey });
      const data = await this.shareNewService.postshareDataProcess(this.syncId);
      const share_id = data.shareId;
      await this.shareNewService.shareMailInvite(share_id, this.inviteKey, this.sharememberInvite);
    }
    this.spinnerOnSubmit = false;
    this.fileListService.reload();
    this.snackbarService.showMessage("success", `Invitations to ‘${this.filename}’ successfully sent.`);
    this.closeDialog();
    if (this.isNewFolder) {
      this.snackbarService.showMessage('success', `'${this.filename}' was successfully created. Shared folder invitations sent.`)
    } else {
      this.snackbarService.showMessage('success', `Invitations to '${this.filename}' successfully sent.`)
    }

    this.shareFolderSuccess.emit(true);
  }

  public makeShare = () => {

    if (this.isVerified && !this.isShareLimit && !this.spinnerOnSubmit) {
      if (!this.loadingOnShareInfo) {
        if (!this.isNewFolder) {
          this.blendService.track(BlendEvent.BUTTON_CLICKED, { button_text: 'Invite (to share)' });
        }
      }
    }

    // this.isChecking = true;
    if (!this.newShareFolderNameValid) {
      this.completed = 0;

      if (!this.sharememberInvite.displayName) {
        this.errors.push({ code: 1654 });
        this.errcode = ErrCode.fromException({ code: 1654 });
        return;
      }

      this.spinnerOnSubmit = true;
      if (this.selected && this.selected[0] && this.selected[0].is_hide_share && this.selected[0].is_shared) {
        // This effectively just "Un-hides" the share
        this.loggerService.info('Share New: Adding share to hidden share.');
        return this.unhideShare();
      } else if (this.syncId) {
        this.loggerService.info('Share New: Converting existing directory to share');
        return this.convertShare();
      } else {
        this.loggerService.info('Share New: Creating new directory for new share');
        return this.newShare();
      }
    } else {
      this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      this.spinnerOnSubmit = false;
    }

  }

  private unhideShare = async () => {
    try {
      if (!this.selected[0].share_id) {
        // TODO Errors
        this.loggerService.error('Directory is a hidden share but doesn\'t have a share_id');
        this.errors.push({ code: 11201 });
        this.errcode = ErrCode.fromException({ code: 11201 });
        return;
      }

      const shareData = await this.shareService.getShare(this.selected[0].share_id)
        .catch((err) => {
          this.handleErr(err);
          return;
        });

      if (!shareData) {
        this.loggerService.error(`No sharedata for share_id=${this.selected[0].share_id}`);
        this.errors.push({ code: 11201 });
        this.errcode = ErrCode.fromException({ code: 11201 });

      } else {
        this.shareNewService.addMember(shareData, this.sharememberInvite).then(() => {
          this.spinnerOnSubmit = false;
          this.closeDialog();
        }).catch((err) => {
          this.spinnerOnSubmit = false;
          this.handleErr(err);
          return;
        });
      }
    } catch (error) {
      console.error(error);

    }
  }

  private convertShare = async () => {
    try {
      if (
        !this.validateService.isDisplayNameValid(
          this.sharememberInvite.displayName
        )
      ) {
        this.handleErr({ code: 1659 });
        return;
      }
      this.shareJobSubscription = this.shareNewService
        .mkShare(
          this.syncId,
          this.filename,
          this.filename,
          this.sharememberInvite,
          null,
          this.bg
        )
        .subscribe(
          (next) => {
            if (next.count) {
              this.updateProgress(next);
            } else {
              this.shareId = next.shareId;
              this.inviteKey = next.inviteKey;
              this.cachekey = next.cachekey;
              this.bg = next.bg;
              this.sharekey = next.sharekey;
              this.postmkShareSteps();
            }
          },
          (error) => {
            this.handleErr(error);
          },
          () => {
            // this.spinnerOnSubmit = false;
          }
        );
    } catch (err) {
      this.loggerService.error(`error in convertShare: ,${err}`);
      this.handleErr(err);
    }
  }

  private newShare = () => {
    try {
      if (!this.isValid() && !this.syncId) {
        this.spinnerOnSubmit = false;
        return;
      }
      if (
        !this.validateService.isDisplayNameValid(
          this.sharememberInvite.displayName
        )
      ) {
        this.handleErr({ code: 1659 });
        return;
      }
      if (!this.pid) {
        const routeSyncId = this.route.snapshot.params['sync_id'];
        this.pid = parseInt(routeSyncId, 10);
      }     
      this.fileListService
        .mkdir(this.pid, this.filename)
        .then((data) => {
          this.syncId = data.pathitem.sync_id;
          return this.shareNewService
            .mkShare(
              this.syncId,
              this.filename,
              this.filename,
              this.sharememberInvite,
              null,
              this.bg
            )
            .toPromise()
            .then((next) => {
              this.shareId = next.shareId;
              this.inviteKey = next.inviteKey;
              this.cachekey = next.cachekey;
              this.bg = next.bg;
              this.sharekey = next.sharekey;
              this.postmkShareSteps();
            });
        })
        .catch((err) => this.handleErr(err));
    } catch (err) {
      this.loggerService.error(`error in newShare: ,${err}`);
      this.handleErr(err);
    }
  }

    /**
   * check if folder name is valid
   * @returns boolean true/false
   */
    public isValid(): boolean {
      if (!this.filename) {
        this.errorMessage = 'Enter a valid folder name.';
        return false;
      }
      if (this.validateService.hasLeadingSpace(this.filename)) {
        this.errorMessage = 'Files cannot begin with a space.';
        return false;
      }
      if (this.validateService.hasTrailingChar(this.filename)) {
        this.errorMessage = 'Files cannot end in a . or a space.';
        return false;
      }
      if (this.validateService.hasReservedNames(this.filename)) {
        this.errorMessage = 'This name is a reserved and cannot be used.';
        return false;
      }
      if (this.validateService.hasIllegalCharacters(this.filename)) {
        this.errorMessage = `Enter a valid folder name.`;
        throw { code: 7246 };
      }
      if (this.validateService.isExist(this.filename, this.pathlist)) {
        this.errorMessage = 'Enter a valid folder name.';
        throw { code: 7245 };
      }
      if (this.filename.length > Constants.MAX_FILE_NAME_LEN) {
        this.errorMessage = `The length of the folder name should not be greater than ${Constants.MAX_FILE_NAME_LEN}`;
        return false;
      }
      this.errorMessage = '';
      return true;
    }

  private handleErr = (err: any) => {
    this.spinnerOnSubmit = false;
    if (typeof err === 'object') {
      if (err.error_code) {
        this.errors.push({ code: err.error_code, msg: err.error_msg });
        this.errcode = ErrCode.fromException({ code: err.error_code, msg: err.error_msg });
      } else if (err.code) {
        this.errors.push(err);
        this.errcode = ErrCode.fromException(err);
      } else {
        this.errors.push({ code: 1000, msg: 'An unknown error occurred' });
        this.errcode = ErrCode.fromException({ code: 1000, msg: 'An unknown error occurred' });
      }
    }
  }

  private updateProgress = (prog: any) => {
    this.count = prog.count;
    this.completed += prog.completed;
    if (prog.completed >= prog.count) {
      // we're done
    }
  }

  onShareFolder = () => {
    this.makeShare()
  }
  closeDialog = () => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
    }, 50);
  }

  cancelDialog = () => {
    this.showDialog = false;
    setTimeout(() => {
      this.showDialogChange.next(false);
      this.cancel.next();
    }, 50);
  }
}
